module.exports = __webpack_public_path__ + "static/img/13.7db52b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/sp/13.png
// module id = Dbfe
// module chunks = 0